import api from '../api'

//data
const state = {
  status: {
    loading: false,
    loaded: false,
    error: '', // last error
    lastLoaded: '',
    warnings: false
  },

  list: [],
  details:{},
  items:{},
  nextDelivery:[], //used to keep info on simulated schedule to clarify when next order will be issued after first one is delivered
  savings:0 //how mutch customer can save if cart is converted to autoship
}

//comuted store.getters.inCart
const getters = {

  getAutoShipStoreStatus: (state) => {
    return state.status
  },

  getAutoShipItems: (state) => {

    return state.items
  },


}

//sync methods store.commit('increment')
const mutations = {
  LOADING_AUTOSHIP(state, isLoading) {
    state.status.loading = isLoading
  },

  SET_AUTOSHIP(state, items) {
    state.list = items
  },

  SET_AUTOSHIP_DETAILS(state, details) {
    state.details = details
  },
  SET_AUTOSHIP_ITEMS(state, items) {
    state.items = items
  },

  UPDATE_AUTOSHIP_DETAILS_FIELD(state, [field,value]) {
    //overried for status
    if(field == 'status'){
      value = (state.details.status == 0) ? 1 : 0;
    }
    state.details[field] = value
  },

  ADD_AUTOSHIP_ITEM(state,item){
    state.items.push(item)
  },
  UPDATE_AUTOSHIP_ITEM(state,item){
    var items = JSON.parse(JSON.stringify(state.items)); //without copying it will not work
    var index = state.items.findIndex(o => o.id === item.id);
    if(index >=0){
      items[index] = item
      state.items = items; //update by index will not work
    }
    else console.error('Item not found in cart Store state')

  },
  REMOVE_AUTOSHIP_ITEM (state, item){
    var items = JSON.parse(JSON.stringify(state.items)); //without copying it will not work
    var index = state.items.findIndex(o => o.id === item.id);
    if(index >=0){
      items.splice(index, 1)
      state.items = items; //update by index will not work
    }
    else console.error('Item not found in cart Store state')


  },
  REMOVE_AUTOSHIP (state, item){
    var list = JSON.parse(JSON.stringify(state.list)); //without copying it will not work
    var index = state.list.findIndex(o => o.id === item.id);
    if(index >=0){
      list.splice(index, 1)
      state.list = list; //update by index will not work
    }
    else console.error('Item not found in cart Store state')

  },

  SET_AUTOSHIP_SAVINGS(state, savings) {
    state.savings = savings
  },

  SET_AUTOSHIP_DELIVERY(state, nextDelivery) {
    state.nextDelivery = nextDelivery
  },

  SET_AUTOSHIP_WARNINGS(state, warnings) {
    state.status.warnings = warnings
  },



}

//async methods  store.dispatch('increment')
const actions = {

  loadAutoship(context) {
    context.commit('LOADING_AUTOSHIP', true);
    return api.get('cart/autoship')
      .then(function(response) {
        context.commit('SET_AUTOSHIP', response.data.data)
        context.commit('LOADING_AUTOSHIP', false);
        return Promise.resolve(response);
      })
      .catch(function(error) {
        context.commit('LOADING_AUTOSHIP', false);
        console.log(error);
        return Promise.reject(error);
      });


  },

  loadAutoshipDetails(context, id) {
    context.commit('LOADING_AUTOSHIP', true);
    return api.get('cart/autoship/'+id)
      .then(function(response) {
        context.commit('SET_AUTOSHIP_DETAILS', response.data.data)
        context.commit('LOADING_AUTOSHIP', false);

        return Promise.resolve(response);
      })
      .catch(function(error) {
        context.commit('LOADING_AUTOSHIP', false);

        return Promise.reject(error);
      });

  },

  cloneAutoship(context, id) {

    context.commit('LOADING_AUTOSHIP', true);
    return api.get('cart/autoship/clone/'+id)
      .then(function(response) {
        context.commit('SET_AUTOSHIP_DETAILS', response.data.data)

        context.commit('LOADING_AUTOSHIP', false);

        return Promise.resolve(response);
      })
      .catch(function(error) {
        context.commit('LOADING_AUTOSHIP', false);

        return Promise.reject(error);
      });

  },



  loadAutoshipItems(context, id) {
    context.commit('LOADING_AUTOSHIP', true);
    return api.get('cart/'+id+'/item')
      .then(function(response) {

        context.commit('SET_AUTOSHIP_ITEMS', response.data.data)
        context.commit('LOADING_AUTOSHIP', false);
        return Promise.resolve(response);
      })
      .catch(function(error) {
        context.commit('LOADING_AUTOSHIP', false);
        console.log(error);
        return Promise.reject(error);
      });

  },


    updateAutoship(context, autoship) {

      if (autoship.delivery_date == "") {
        //commit('SET_TEMP_DELIVERY_DATA', ['', cart.address_id]);
        return;
      }

      //verify if address or date has changed
      if (state.details.address_id == autoship.address_id
        && state.details.delivery_date == autoship.delivery_date
        && state.details.notes == autoship.notes
        && state.details.payment_type == autoship.payment_type
        && state.details.status == autoship.status
        && state.details.pause == autoship.pause
        && state.details.pause_from == autoship.pause_from
        && state.details.pause_to == autoship.pause_to
        && state.details.week_day == autoship.week_day
        && state.details.frequency == autoship.frequency
        && state.details.valid_from == autoship.valid_from
        && state.details.valid_to == autoship.valid_to
        && state.details.autoship_name == autoship.autoship_name
        ) return;

      context.commit('LOADING_AUTOSHIP', true);
      return api.post('cart/autoship/'+autoship.id, autoship)
        .then(function(response) {
          context.commit('SET_AUTOSHIP_DETAILS', response.data.data)
          context.commit('LOADING_AUTOSHIP', false);
          return Promise.resolve(response);
        })
        .catch(function(error) {
          context.commit('LOADING_AUTOSHIP', false);
          console.log(error);
          return Promise.reject(error);
        });

    },


    processAutoship(context, autoship) {


      if (autoship.delivery_date == "") {
        //commit('SET_TEMP_DELIVERY_DATA', ['', cart.address_id]);

        return;
      }

      context.commit('LOADING_AUTOSHIP', true);
      return api.post('cart/autoship/process/'+autoship.id, autoship)
        .then(function(response) {
          context.commit('SET_AUTOSHIP_DETAILS', response.data.data)
          context.commit('LOADING_AUTOSHIP', false);
          return Promise.resolve(response);
        })
        .catch(function(error) {
          context.commit('LOADING_AUTOSHIP', false);
          console.log(error);
          return Promise.reject(error);
        });

    },


    //add or update
    addAutoshipItem ({state, commit},[cartId, item]) {

      //commit('LOADING_CART', true);

      return api.post('cart/'+cartId+'/cartitem', item)
        .then(function (response) {
          if(item.id && item.order == 0 && item.return == 0){
            commit('REMOVE_AUTOSHIP_ITEM', response.data.data)
          }
          else if(item.id){
            commit('UPDATE_AUTOSHIP_ITEM', response.data.data)
          }
          else commit('ADD_AUTOSHIP_ITEM', response.data.data)

          return Promise.resolve(response);

        })
        .catch(function (error) {
        //  commit('LOADING_CART', false);
          return Promise.reject(error);


        });
    },



    removeAutoshipItem ({state, commit},item) {

      commit('LOADING_AUTOSHIP', true);

      return api.delete('cart/' + item.cart_id + '/item/'+ item.good_id)
        .then(function (response) {

           commit('REMOVE_AUTOSHIP_ITEM', item)
           commit('LOADING_AUTOSHIP', false);
           return Promise.resolve(response);

        })
        .catch(function (error) {
          commit('LOADING_AUTOSHIP', false);
          return Promise.reject(error);


        });
    },

    deleteAutoship ({state, commit},item) {

      commit('LOADING_AUTOSHIP', true);

      api.delete('cart/autoship/' + item.id)
        .then(function (response) {
           commit('REMOVE_AUTOSHIP', item)
          commit('LOADING_AUTOSHIP', false);
        })
        .catch(function (error) {
          commit('LOADING_AUTOSHIP', false);


        });
    },


    addAutoship ({state, commit},item) {

      commit('LOADING_AUTOSHIP', true);

      return api.post('cart/autoship')
        .then(function (response) {
          commit('SET_AUTOSHIP_DETAILS', response.data.data)
          commit('LOADING_AUTOSHIP', false);
          return Promise.resolve(response);
        })
        .catch(function (error) {
          commit('LOADING_AUTOSHIP', false);
          return Promise.reject(error);

        });
    },

    convertCartToAutoship ({state, commit},cart) {

      //commit('LOADING_CART', true);
      commit('SET_AUTOSHIP_WARNINGS', false)
      return api.post('cart/'+cart.id+'/converttoautoship')
        .then(function (response) {

          commit('SET_AUTOSHIP_WARNINGS', response.data.warnings)
          return Promise.resolve(response);

        })
        .catch(function (error) {

          return Promise.reject(error);


        });
    },

    getNextDelivery ({state, commit},cart) {

      return api.get('cart/autoship/'+cart.original_id+'/nextdelivery?delivery_date='+cart.delivery_date)
        .then(function (response) {

          commit('SET_AUTOSHIP_DELIVERY',response.data.next_delivery)
          return Promise.resolve(response);

        })
        .catch(function (error) {

          return Promise.reject(error);


        });
    }





}


export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/AutoShipStore.js